<template>
  <v-form ref="form">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          clearable
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.ncmId"
          v-bind="getObject('ncmId')"
          label="NCM"
          :search-input.sync="ncmSearch"
          :items="extraData.allAvailableNcms"
          item-text="text"
          item-value="id"
          :loading="loadingNcms"
          @change="selectNcm"
          key="entry.ncmId"
          placeholder="Digite 3 letras ou mais para pesquisar um NCM disponível"
          hide-no-data
          no-filter
          autocomplete="new"
          :disabled="readOnly"
        />
      </v-col>
      

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemType"
          v-bind="getObject('itemType')"
          label="Tipo"
          :items="extraData.globalContext.allCultureItemTypes"
          item-text="text"
          item-value="value"
          autocomplete="new"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" v-if="entry.itemType !=null && entry.itemType != 'Fertilizer' && entry.itemType != 'Part'">
        <v-autocomplete
          v-model="entry.cultureIdsAttributes"
          label="Cultura(s)"
          :items="extraData.globalContext.allCultures"
          item-text="name"
          item-value="id"
          multiple
          chips
          deletable-chips
          autocomplete="new"
          :disabled="readOnly"
        />
      </v-col>


      <v-col cols="12" v-if="entry.itemType !=null && entry.itemType != 'Fertilizer' && entry.itemType != 'Part'">
        <MultiSelect
          v-model="entry.subCultureIdsAttributes"
          v-bind="getObject('subCultureIdsAttributes')"
          label="Sub culturas"
          :items="subCulturesList"
          :loadingItems="subCulturesListLoading"
          :maxLimit="null"
          itemSubText="additionalInfo"
          :readOnly="readOnly"
        >          
        </MultiSelect>
      </v-col>

      <v-col cols="12" v-if="entry.itemType !=null && entry.itemType == 'Fertilizer'">
        <MultiSelect
          v-model="entry.itemIdsAttribute"
          v-bind="getObject('itemIdsAttribute')"
          label="Fertilizantes"
          :items="fertilizersList"
          :loadingItems="fertilizersListLoading"
          :maxLimit="null"
          itemSubText="additionalInfo"
          :readOnly="readOnly"
        >
        </MultiSelect>
      </v-col>

      <v-col cols="12" v-if="entry.itemType !=null && entry.itemType == 'Part'">
        <MultiSelect
          v-model="entry.itemIdsAttribute"
          v-bind="getObject('itemIdsAttribute')"
          label="Peças"
          :items="partsList"
          :loadingItems="partsListLoading"
          :maxLimit="null"
          itemSubText="additionalInfoForGroupTaxes"
          :readOnly="readOnly"
        >
        </MultiSelect>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import gql from 'graphql-tag';
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      loadingNcms: false,
      ncmId: null,
      ncmSearch: null,
      ncmSearchTimeout: null,
      itemsSearchTimeout: null,
      pageLoading: false,
      subCulturesList:[],
      subCulturesListLoading: false,
      fertilizersList:[],
      fertilizersListLoading: false,
      partsList:[],
      partsListLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  watch: {
    ncmSearch: {
      // immediate: true,
      handler(val, oldVal) {

        // Items have already been requested
        // if (this.loadingNcms) {
        //   return;
        // }
        // console.log("this.entry.ncm: ", this.entry.ncm)
        // console.log("val:" + val)

        if (val == "" || (val && val.length < 3)) {
          return;
        }

        if (this.entry.ncm && this.entry.ncm.text == val){
          return;
        }

        clearTimeout(this.ncmSearchTimeout);
        this.ncmSearchTimeout = setTimeout(() => {
          this.loadNcmsList(val);
        }, 500);
      }
    },
    'entry.itemType': {
      handler(old, oldVal){
        // console.log("changed");
        // console.log("en", this.entry);
        if(this.entry.itemType == 'Fertilizer'){
          this.loadFertilizersList();
        }

        if(this.entry.itemType == 'Part'){
          this.loadPartsList();
        }
      }
    },
    'entry.cultureIdsAttributes': {
      handler(old, oldVal){
        this.loadSubCulturesList();
      }
    },
  },
  created() {
    this.setupEntryAttributes(this.entry, this.entryAttributes);
    if(this.entry.itemType == 'Fertilizer'){
      this.loadFertilizersList();
    }
    if(this.entry.cultureIdsAttributes){
      this.loadSubCulturesList();
    }
    if(this.entry.itemType == 'Part'){
      this.loadPartsList();
    }
    // this.entry.itemIdsAttributes=[];
  },
  methods: {
    selectNcm: function() {
      this.entry.ncm = this.extraData.allAvailableNcms.find(obj => obj.id == this.entry.ncmId);
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    loadNcmsList: function(searchQuery) {
      this.loadingNcms = true;
      this.$apollo
        .query({
          query: ALL_AVAILABLE_NCMS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            taxationGroupId: (this.entry.id ? this.entry.id : ''),
            query: searchQuery
          }
        })
        .then(response => {
          this.extraData.allAvailableNcms = response.data.globalContext.allAvailableNcms;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingNcms = false));

    },
    loadSubCulturesList: function() {
      this.subCulturesListLoading = true;
      this.$apollo
        .query({
          query: ALL_SUB_CULTURES_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            cultureIds: this.entry.cultureIdsAttributes
          }
        })
        .then(response => {
          // console.log("subc", response.data.globalContext);
          this.subCulturesList = response.data.globalContext.allSubCulturesForCulture;
        })
        .catch(response => console.log(response))
        .finally(() => (this.subCulturesListLoading = false));

    },
    loadFertilizersList: function() {
      this.fertilizersListLoading = true;
      this.$apollo
        .query({
          query: ALL_FERTILIZERS_QUERY,
          fetchPolicy: "no-cache",
          variables: {            
          }
        })
        .then(response => {
          this.fertilizersList = response.data.globalContext.allFertilizers;
          // console.log(this.fertilizersList);

        })
        .catch(response => console.log(response))
        .finally(() => (this.fertilizersListLoading = false));
    },
    loadPartsList: function() {
      this.partListLoading = true;
      this.$apollo
        .query({
          query: ALL_PARTS_QUERY,
          fetchPolicy: "no-cache",
          variables: {            
          }
        })
        .then(response => {
          this.partsList = response.data.globalContext.allParts;
          // console.log(this.partList);
        })
        .catch(response => console.log(response))
        .finally(() => (this.partListLoading = false));
    },
    
  }
};

const ALL_AVAILABLE_NCMS_QUERY = gql `
  query($taxationGroupId: ID, $query: String) {
    globalContext {
      allAvailableNcms(taxationGroupId: $taxationGroupId, query: $query) {
        id
        text
      }
    }
  }
`;

const ALL_SUB_CULTURES_QUERY = gql `
  query($cultureIds: [ID!]!){
    globalContext {
      allSubCulturesForCulture(cultureIds: $cultureIds) {
        id
        name
        additionalInfo
      }
    }
  }
`;

const ALL_FERTILIZERS_QUERY = gql `
  {
    globalContext {
      allFertilizers {
        id
        name
        text
        additionalInfo
      }
    }
  }
`;

const ALL_PARTS_QUERY = gql `
  {
    globalContext {
      allParts {
        id
        name
        additionalInfoForGroupTaxes
        additionalInfo
      }
    }
  }
`;

</script>

<style scoped></style>
